import React, { useRef } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import UserStore from "../../store/UserStore";
import { getDecodedToken } from "../../utils/functions";
import LoadingScreen from "../LoadingScreen/LoadingScreen";

const CheckRoutes = ({ children }) => {
  const userRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const notCustomer = (path) => {
    switch (path) {
      case "linkedclients":
        navigate("/not-found");
        break;
      case "selectfamilies":
        navigate("/not-found");
        break;
      case "nolinkedclients":
        navigate("/not-found");
        break;
      case "unlockaccount":
        navigate("/not-found");
        break;
      default:
        break;
    }
  };

  const notEmpRoute = (path) => {
    switch (path) {
      case "linkedclients":
        navigate("/not-found");
        break;
      case "nolinkedclients":
        navigate("/not-found");
        break;
      case "welcome":
        navigate("/not-found");
        break;
      case "aboutus":
        navigate("/not-found");
        break;
      case "upload":
        navigate("/not-found");
        break;
      default:
        break;
    }
  };
  const notManagerRoute = (path) => {
    switch (path) {
      case "selectfamilies":
        navigate("/not-found");
        break;
      case "unlockaccount":
        navigate("/not-found");
        break;
      default:
        break;
    }
  };

  const checkUser = () => {
    const pathname = location.pathname?.split("/");
    const userType = getDecodedToken()?.user_type;
    if (userType === "customer") {
      notCustomer(pathname[1]);
    } else if (userType === "employee") {
      notEmpRoute(pathname[1]);
    } else {
      notManagerRoute(pathname[1]);
    }
  };

  userRef.current = checkUser;

  useEffect(() => {
    userRef.current();
  }, []);
  return <div>{!UserStore.isHydrated ? <LoadingScreen /> : children}</div>;
};

export default CheckRoutes;
